/* 设置localStorage */
export function setStore (name, content) {
  if (!name) return
  if (typeof content !== "string") {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}
/* 获得localStorage */
export function getStore (name) {
  if (!name) return
  return window.localStorage.getItem(name)
}
/* 删除localStorage */
export function removeStore (name) {
  if (!name) return
  window.localStorage.removeItem(name)
}

// 设置 cookie 增加到vue 实力 方便全局调用
export function setCookie (cName, value, expiredays) {
  let exdate = new Date()
  exdate.setTime(exdate.getTime() + expiredays)
  // escape() 函数可对字符串进行编码，这样就可以在所有的计算机上读取该字符串
  document.cookie = cName + "=" + escape(value) + ((expiredays == null) ? "" : "; expires =" + exdate.toGMTString())
}
// 获取 cookie
export function getCookie (name) {
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
  let arr = []
  arr = document.cookie.match(reg)
  if (arr) {
    return (arr[2])
  } else {
    return null
  }
}
// 删除cookie
export function delCookie (name) {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + "=" + cval + "; expires =" + exp.toGMTString()
  }
};
